import React, { useState, useEffect, useReducer } from 'react';
import { Auth } from 'aws-amplify';
import { Spinner } from 'components';
import UserContext, { UserProvider } from 'context/UserContext';
import { ShopProvider } from 'context/ShopContext';
import { withRouter } from 'react-router-dom';
import { parseQueryString } from 'lib/query-string';
import useShop from 'hooks/useShop';
import { SetItemReducer, SET_ITEM, SET_ALL } from 'reducers/SetItemReducer';
import { GET_SHOP_SETTINGS } from 'Queries';
import { SHOP_DEFAULT_SETTINGS } from 'lib/globals';
import { SCOPE, SHOPIFY_API_KEY, SHOPIFY_EMBEDDED_FORCE_REDIRECT } from 'aws-exports';
import AppLocalStorage from 'lib/AppLocalStorage';
import { createApp } from '@shopify/app-bridge';
import { getScriptStatus } from './cart/Utils';

const Authenticator = ({ children, location }) => {
    return <WithShopProvider shopName={window.shop}>{children}</WithShopProvider>;
};

export default withRouter(Authenticator);

const WithShopProvider = ({ children, shopName }) => {
    const [validationErrors, setValidationErrors] = useState({});
    const [state, dispatch] = useReducer(SetItemReducer, {});
    const params = new URLSearchParams(window.location.search);
    const { data, error, loading } = useShop(shopName, GET_SHOP_SETTINGS, {}, 'cache-first');
    const setItem = (path, value) => dispatch({ type: SET_ITEM, path, value });
    const discard = () => {
        if (data && data?.shop) {
            const { shop } = data;
            dispatch({
                type: SET_ITEM,
                path: 'settings',
                value: shop.settings || SHOP_DEFAULT_SETTINGS()
            });
        }
    };

    const [cartActive, setCartActive] = useState(false);
    const [cartLoading, setCartLoading] = useState(true);

    // const hasRecharge = async (shop_url: string) => {
    //   const { data } = await Axios.get(
    //     `https://static.rechargecdn.com/store/${shop_url}/product/2020-12/products.json`
    //   );
    //   return !!data?.widget_settings;
    // };

    useEffect(() => {
        async function checkScope(shop) {
            // console.log("#################")
            // console.log(shop.scope)
            // console.log(SCOPE)
            // console.log(shop.version)
            // console.log("#################")
            if (shop.scope !== SCOPE || !shop.version || shop.version !== '1.0.3') {
                // await logOutUser(shop);
            }
        }
        if (data && data?.shop) {
            const { shop } = data;
            checkScope(shop);
            const default_settings = SHOP_DEFAULT_SETTINGS(
                state.settings ? state.settings.default_language : 'english'
            );

            const shop_settings = shop.settings;

            if (shop_settings && !shop_settings.modules.checkout_button.coupon_alert_text) {
                shop_settings['modules']['checkout_button']['coupon_alert_text'] =
                    default_settings['modules']['checkout_button']['coupon_alert_text'];
            }
            // if (shop_settings && !shop_settings.modules.order_note) {
            //   shop_settings["modules"]["order_note"] = {
            //     active: false,
            //     ...default_settings["modules"]["order_note"]
            //   };
            // }
            // if (
            //   shop_settings &&
            //   shop_settings["modules"]["order"].indexOf("order_note") === -1
            // ) {
            //   shop_settings["modules"]["order"].push("order_note");
            // }
            if (shop_settings && !shop_settings['cod_settings']) {
                shop_settings['cod_settings'] = default_settings.cod_settings;
            }
            if (shop_settings && !shop_settings['subscription']) {
                shop_settings['subscription'] = default_settings.subscription;
            } else if (
                shop_settings &&
                shop_settings['subscription'] &&
                !shop_settings['subscription'].upgradingText
            ) {
                shop_settings['subscription'] = {
                    ...shop_settings['subscription'],
                    downgradingText: default_settings.subscription.downgradingText,
                    upgradingText: default_settings.subscription.upgradingText,
                    loadingBackground: default_settings.subscription.loadingBackground,
                    loadingBorder: default_settings.subscription.loadingBorder,
                    subscribedText: default_settings.subscription.subscribedText,
                    subscribedBackground: default_settings.subscription.subscribedBackground,
                    subscribedBorder: default_settings.subscription.subscribedBorder
                };
            }
            if (shop_settings && !shop_settings.hasOwnProperty('open_cart')) {
                shop_settings['open_cart'] = true;
            }
            if (shop_settings && !shop_settings.hasOwnProperty('show_coupon')) {
                shop_settings['show_coupon'] = true;
            }
            if (shop_settings && !shop_settings.hasOwnProperty('show_coupon_alert_text')) {
                shop_settings['show_coupon_alert_text'] = true;
            }
            if (shop_settings && !shop_settings['sticky_cart']) {
                shop_settings['sticky_cart'] = default_settings.sticky_cart;
            }
            if (shop_settings && !shop_settings['scary']) {
                shop_settings['scary'] = default_settings.scary;
            }
            if (
                shop_settings &&
                !shop_settings['modules']['checkout_button']['continue_shopping_button']
            ) {
                shop_settings['modules']['checkout_button']['continue_shopping_button'] =
                    default_settings.modules.checkout_button.continue_shopping_button;
                shop_settings['modules']['checkout_button']['active_continue_shopping_button'] =
                    default_settings.modules.checkout_button.active_continue_shopping_button;
                shop_settings['modules']['checkout_button']['active_continue_shopping_underlined'] =
                    default_settings.modules.checkout_button.active_continue_shopping_underlined;
            }
            if (shop_settings && !shop_settings['checkout_condition_text']) {
                shop_settings['checkout_condition_text'] = default_settings.checkout_condition_text;
                shop_settings['checkout_condition_color'] =
                    default_settings.checkout_condition_color;
                shop_settings['is_checkout_condition_active'] = false;
            }
            if (shop_settings && !shop_settings['continue_shopping_button']) {
                shop_settings['continue_shopping_button'] =
                    default_settings.continue_shopping_button;
                shop_settings['active_continue_shopping_button'] =
                    default_settings.active_continue_shopping_button;
                shop_settings['active_continue_shopping_underlined'] =
                    default_settings.active_continue_shopping_underlined;
            }

            if (shop_settings && !shop_settings.sticky_cart['desktop_quantity']) {
                shop_settings.sticky_cart.desktop_quantity =
                    default_settings.sticky_cart.desktop_quantity;
                shop_settings.sticky_cart.mobile_quantity =
                    default_settings.sticky_cart.mobile_quantity;
                shop_settings.sticky_cart.cart_name = default_settings.sticky_cart.cart_name;
            }
            if (shop_settings && !shop_settings.badges) {
                shop_settings.badges = default_settings.badges;
                shop_settings.badges.isActive = false;
            }
            if (shop_settings && !shop_settings.announcement) {
                shop_settings.announcement = default_settings.announcement;
                shop_settings.announcement.isActive = false;
            }
            if (shop_settings && !shop_settings.afterPay) {
                shop_settings.afterPay = default_settings.afterPay;
            }
            if (shop_settings && !shop_settings.auto_discount) {
                shop_settings.auto_discount = {
                    text: {
                        ...default_settings.scary.text,
                        font_size: 0.9,
                        font_weight: 400,
                        text: '{{title}}'
                    },
                    background: default_settings.scary.background,
                    border: default_settings.scary.border
                };
            }
            if (shop_settings && shop_settings.product.show_bin == null) {
                shop_settings.product['show_bin'] = true;
            }
            if (shop_settings && shop_settings.product.allow_variants_editing == null) {
                shop_settings.product['allow_variants_editing'] = false;
            }
            if (shop_settings && shop_settings.product.editable_quantity == null) {
                shop_settings.product['editable_quantity'] = false;
            }
            if (shop_settings && !shop_settings.product.bin_color) {
                shop_settings.product['bin_color'] = {
                    a: 1,
                    r: 119,
                    g: 119,
                    b: 119
                };
            }
            if (shop_settings && !shop_settings.product.variants) {
                shop_settings.product['variants'] = {
                    color: {
                        a: 1,
                        r: 119,
                        g: 119,
                        b: 119
                    },
                    font_size: 0.9,
                    font_weight: 500
                };
            }
            dispatch({
                type: SET_ALL,
                value: {
                    ...shop,
                    settings: shop_settings || default_settings,
                    // settings: default_settings,
                    // show_recharge_alert,
                    original_settings: shop.settings || {},
                    settingsSaved: !!shop.settings ? true : false, //TODO: this will be deprecated
                    redirectToChargeApproval: !shop.chargeAccepted
                }
            });
        }
    }, [data]);

    useEffect(() => {
        if (!data?.shop?.id || !window.location.origin) return;

        let intervalId;

        async function checkStatus() {
            await getScriptStatus(data.shop.id, window.location.origin, (status, error) => {
                if (!error) {
                    setCartActive(status);

                    if (status === true && intervalId) {
                        clearInterval(intervalId);
                        intervalId = null;
                    }
                }
                setCartLoading(false);
            });
        }

        checkStatus();

        intervalId = setInterval(checkStatus, 3000);

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [data]);

    if (error) {
        console.log(error);
        throw new Error(error);
    }
    if (loading || !Object.keys(state).length) return <Spinner text="Fetching shop data" />;
    else if (data) {
        const config = {
            apiKey: SHOPIFY_API_KEY,
            shopOrigin: state.id,
            forceRedirect: SHOPIFY_EMBEDDED_FORCE_REDIRECT,
            host: params.get('host') || btoa(state.id)
        };
        const app = createApp(config);
        return (
            <ShopProvider
                value={{
                    state,
                    setItem,
                    dispatch,
                    discard,
                    validationErrors,
                    setValidationErrors,
                    AppLocalStorage: AppLocalStorage(state, setItem, app),
                    setup: {
                        cartActive,
                        cartLoading,
                        setCartLoading
                    }
                }}
            >
                <UserProvider
                    value={{
                        attributes: {
                            website: data?.shop.id,
                            sub: data?.shop.userId
                        }
                    }}
                >
                    {children}
                </UserProvider>
            </ShopProvider>
        );
    }
};
